<template>
    <button
        type="button"
        role="switch"
        :aria-checked="String($colorMode.isDark)"
        :aria-label="$t('footer.theme_toggle')"
        class="theme-switch inline-flex items-center gap-2"
        @click="$colorMode.toggle()"
    >
        <i class="ri-sun-line text-base leading-none" aria-hidden="true" />
        <span
            class="relative block w-10 h-6 rounded-full bg-grey-300 dark:bg-green transition-colors"
            aria-hidden="true"
        >
            <span
                class="absolute top-0.5 left-0.5 w-5 h-5 rounded-full bg-white shadow-sm transition-transform"
                :class="$colorMode.isDark && 'translate-x-4'"
            />
        </span>
        <i class="ri-moon-line text-base leading-none" aria-hidden="true" />
    </button>
</template>

<script>
export default {
    name: 'ThemeSwitch',
};
</script>
